import { TRANSLATIONS } from 'translations/index';

import {
  isRequired,
  isRequiredCurrency,
  isValidUploadedImageSize,
  isValidUploadedImageFormat
} from 'utils/validators';

const validate = (values, props) => {
  const errors = {};

  const { languages } = props;
  const secondLanguage = languages[languages.length - 1];

  if (values.addOns && values.addOns.length) {
    const addOns = values.addOns;
    const addOnsArrayErrors = [];

    addOns.forEach((item, itemIndex) => {
      let addOnsErrors = {};

      if (languages.length > 1) {
        if (
          !item[secondLanguage] ||
          isRequired(item[secondLanguage].title || '', true)
        ) {
          addOnsErrors = {
            [secondLanguage]: {
              title: TRANSLATIONS[secondLanguage].titleIsRequired
            }
          };
          addOnsArrayErrors[itemIndex] = addOnsErrors;
        }
      }

      if (item.coverPhoto) {
        if (isValidUploadedImageSize(item.coverPhoto || '', true)) {
          addOnsErrors.coverPhoto = 'Your file exceeded the size limit';
          addOnsArrayErrors[itemIndex] = addOnsErrors;
        } else if (isValidUploadedImageFormat(item.coverPhoto || '', true)) {
          addOnsErrors.coverPhoto = `File could not be uploaded because the format is not supported. Please upload the file with the format png, jpg, jpeg`;
          addOnsArrayErrors[itemIndex] = addOnsErrors;
        }
      }

      if (isRequired(item.title || '', true)) {
        addOnsErrors.title = 'Title is required';
        addOnsArrayErrors[itemIndex] = addOnsErrors;
      }

      if (isRequiredCurrency(item)) {
        addOnsErrors['USD'] = 'Error';
        addOnsErrors['EUR'] = 'Error';
        addOnsErrors['NOK'] = 'Error';
        addOnsArrayErrors['_error'] = {
          ...addOnsArrayErrors['_error'],
          [itemIndex]:
            'Value for at least one currency for each category should be filled in'
        };
        addOnsArrayErrors[itemIndex] = addOnsErrors;
      }
    });

    if (addOnsArrayErrors.length) {
      errors.addOns = addOnsArrayErrors;
      errors.addOns = {
        ...addOnsArrayErrors,
        _error: { ...addOnsArrayErrors }
      };
    }
  }

  return errors;
};

export default validate;
